//Generated File 
export const AND = `AND`;
export const OR = `OR`;
